// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r5-0";